<template>
    <div class="funcKeys base-button">
        <slot name="funcName"></slot>
    </div>
</template>

<script>
export default { 
    name: 'FuncKeys'

}
</script>

<style scoped>
    .funcKeys{
        width: 1.093333rem;
        height: .693333rem;
        border: .093333rem solid #333;
        font-size: .25rem;
        white-space: pre-wrap;
    }

    .funcKeys::before{
        height: .44rem;
        top: .04rem;    
    }

    .funcKeys::after{
        height: .44rem;
        top: .04rem;
    }    
</style>